import { useState, useEffect } from 'react'

/**
 * 离线状态检测 + 提示 Banner
 * PWA 核心：检测网络状态变化，离线时提示用户
 */
export default function OfflineBanner() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine)
  const [showUpdate, setShowUpdate] = useState(false)

  useEffect(() => {
    const handleOnline = () => setIsOffline(false)
    const handleOffline = () => setIsOffline(true)

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [])

  // 检测 PWA 更新
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      // 监听控制器变化 = 有新版本可用
      let controller = null
      const handleControllerChange = () => {
        if (controller) {
          setShowUpdate(true)
        }
      }
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        controller = navigator.serviceWorker.controller
        handleControllerChange()
      })
    }
  }, [])

  // 应用更新
  const applyUpdate = () => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistration().then(reg => {
        if (reg) {
          reg.waiting?.postMessage({ type: 'SKIP_WAITING' })
        }
      })
    }
    window.location.reload()
  }

  if (showUpdate) {
    return (
      <div className="fixed top-0 left-0 right-0 z-[9999] flex items-center justify-between px-4 py-2.5"
           style={{ background: 'linear-gradient(135deg, #6C63FF, #a29bfe)', color: 'white' }}>
        <span className="text-sm font-medium">
          <i className="fa-solid fa-arrow-up-from-bracket mr-1.5" />
          发现新版本，点击更新
        </span>
        <button
          onClick={applyUpdate}
          className="px-3 py-1 rounded-full text-xs font-bold border-none cursor-pointer"
          style={{ background: 'rgba(255,255,255,0.25)', color: 'white' }}
        >
          立即更新
        </button>
      </div>
    )
  }

  if (!isOffline) return null

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] flex items-center justify-center px-4 py-2"
         style={{ background: '#FF6B6B', color: 'white' }}>
      <i className="fa-solid fa-wifi-slash mr-2 text-sm" />
      <span className="text-sm font-medium">当前处于离线状态，部分功能可能不可用</span>
    </div>
  )
}
